import { ComponentStyleConfig, theme } from '@chakra-ui/react';

export const Input: ComponentStyleConfig = {
  defaultProps: {
    focusBorderColor: 'dynamic.accent',
  },
  variants: {
    network: props => ({
      ...theme.components.Input.variants?.flushed(props),
      focusBorderColor: 'dynamic.highlight',
    }),
  },
};
